import React from "react";
import { LineChart, Activity } from "lucide-react";

/**
 * Renders three inline pill buttons — Trend / Marker Trends / Edit —
 * that switch between the athlete's three top-level views (they all
 * share the same sidebar + selected athlete). Designed to sit inside
 * the athlete "Trends, AI and Reports" action cluster so the nav
 * lives next to Print / AI actions instead of floating above the
 * pane. Active view is rendered with the same `.pill.active` treatment
 * used by other primary actions in the toolbar.
 */
export default function AthleteSubTabs({ activeTab, onSelectTab }) {
  if (!onSelectTab) return null;
  // "Edit" was removed 2026-02-14 — it was a self-reference to the
  // Data Editor itself (clicking it from the Data Editor did nothing
  // visible, confusing coaches). Pressing Esc from Trend / Marker
  // Trends now brings the user back to the Data Editor default view
  // (see the global Esc handler in App.js).
  const tabs = [
    {
      key: "sailor", label: "Trend", Icon: Activity,
      testid: "editor-subtab-trend",
      title: "Longitudinal snapshot — latest values with cohort percentiles",
    },
    {
      key: "marker_trends", label: "Marker Trends", Icon: LineChart,
      testid: "editor-subtab-marker-trends",
      title: "Multi-marker line chart with supplement administration dots on the X-axis",
    },
  ];
  return (
    <>
      {tabs.map(({ key, label, Icon, testid, title }) => {
        const active = activeTab === key;
        return (
          <button
            key={key}
            className={`pill${active ? " active" : ""}`}
            onClick={() => onSelectTab(key)}
            data-testid={testid}
            title={title}
            aria-pressed={active}
          >
            <Icon size={14} /> {label}
          </button>
        );
      })}
    </>
  );
}
